import * as React from "react";
import { Collapse } from "@mui/material";
import { CSSCollapseTransitionComponent } from "../patientCard/layout/CSSCollapseTransitionComponent";

//region [[ Styles ]]

//const SafeCollapseView = styled("div")({});

//endregion [[ Styles ]]

//region [[ Props ]]

export interface SafeCollapseProps {
  in?: boolean;
  timeout?: number;
  inExtension?: boolean;
  children?: any;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const SafeCollapse = ({ ...props }: SafeCollapseProps) => {
  if (props.inExtension) return <CSSCollapseTransitionComponent {...props} />;
  return <Collapse {...props} />;
};
